/**
 * Restrict WebView document previews to trusted storage/CDN hosts.
 * Blocks arbitrary https origins from loading in the in-app browser surface.
 */
export function isDocumentPreviewWebViewUrl(url: string): boolean {
  const trimmed = (url || '').trim();
  if (!trimmed) return false;
  if (trimmed === 'about:blank') return true;
  if (trimmed.startsWith('data:')) return true;
  if (trimmed.startsWith('blob:')) return true;
  try {
    const parsed = new URL(trimmed);
    const host = parsed.hostname.toLowerCase();

    if (parsed.protocol === 'file:') return true;
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return false;

    if (parsed.protocol === 'http:') {
      const dev = typeof __DEV__ !== 'undefined' && __DEV__;
      if (dev && (host === 'localhost' || host === '127.0.0.1')) return true;
      return false;
    }

    if (host.endsWith('.firebasestorage.app')) return true;
    if (host === 'firebasestorage.googleapis.com') return true;
    if (host.endsWith('.googleapis.com')) return true;
    if (host.endsWith('.googleusercontent.com')) return true;

    return false;
  } catch {
    return false;
  }
}

/** Origin patterns for WebView (defense in depth with {@link isDocumentPreviewWebViewUrl}). */
export function getDocumentWebViewOriginWhitelist(): string[] {
  const base = ['https://*', 'file://*', 'about:blank', 'data:*', 'blob:*'];
  if (typeof __DEV__ !== 'undefined' && __DEV__) {
    base.push('http://localhost:*', 'http://127.0.0.1:*');
  }
  return base;
}
